import { render, staticRenderFns } from "./VerAccessionNumber.vue?vue&type=template&id=a553865e&"
import script from "./VerAccessionNumber.vue?vue&type=script&lang=js&"
export * from "./VerAccessionNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports